<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR ESTANQUES DE ACEITE EXTERNOS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        bodegas:[],
        inputs:[
            {tipo:'select', valor:'',   label:'Seleccione Bodega',  key:'bodegas_id',   opciones:[],    texto:'nombre', seleccion:'id'},
            {tipo:'texto',  valor:'',   label:'Nombre *',           key:'nombre_corto'},
            {tipo:'texto',  valor:'',   label:'Descripción *',      key:'nombre'},
            {tipo:'texto',  valor:'',   label:'Capacidad',          key:'capacidad'},
            {tipo:'texto',  valor:'',   label:'Alerta sobre ',      key:'alertar'},
            {tipo:'switch', valor:'1',  label:'Activo',             key:'activo'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Código',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    class:"cabecera",
                    value:'bodega'
                },
                {
                    text: 'Nombre',
                    align: 'center',
                    sortable: true,
                    class:"cabecera",
                    value: 'nombre_corto',
                },
                {
                    text: 'Descripción',
                    align: 'center',
                    sortable: true,
                    class:"cabecera",
                    value: 'nombre',
                },
                {
                    text: 'Capacidad',
                    align: 'center',
                    sortable: true,
                    class:"cabecera",
                    value: 'capacidad',
                },
                {
                    text: 'Alertar',
                    align: 'center',
                    sortable: true,
                    class:"cabecera",
                    value: 'alertar',
                },
                {
                    text: 'Activo',
                    align: 'center',
                    sortable: true,
                    class:"cabecera",
                    value: 'activo_texto',
                },
                { text: 'Acciones', value: 'action', sortable: false, class:"cabecera", align:'center' },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    mounted() {
        this.cargarDatos();
        this.cargarBodegas()
    },
    methods: {
        async cargarDatos(){
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}estanque_externos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data;
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarBodegas(){
            let url = `${this.base_url}bodegas?tipo_produccion_id=2&tipo_bodega=bodega`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log({bodegas_res: res});
                this.bodegas = res.data.data;
                this.inputs[0].opciones = this.bodegas
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Estanque Externo';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'estanque_externos';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Estanque Externo';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `estanque_externos/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
    }
}
</script>